import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import classNames from 'classnames';
import * as React from 'react';
import { CustomModalLayout, Modal } from '@wix/design-system';
import { CurrentPlanInOfferingMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { ModalHeader, ModalHeaderProps } from './ModalHeader';
import { PlanRemovedSectionHelper } from './PlanRemovedSectionHelper';
import CurrentPlanFeatures from './CurrentPlanFeatures';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import s from './styles.scss';

interface ViewCurrentPlanModalProps {
  rootStore: RootStore;
  closeModal(): void;
  isOpen: boolean;
}

const ViewCurrentPlanModalComp: React.FC<ViewCurrentPlanModalProps> = ({
  closeModal,
  isOpen,
  rootStore,
}) => {
  const { appContext, currentPlanInOfferingMode } = rootStore.appStore;
  const [currencyToString] = usePremiumCurrencyFormatter();
  const shouldShowPlanRemoved =
    currentPlanInOfferingMode === CurrentPlanInOfferingMode.ProductNotMatch;

  const { t } = useTranslation();
  const { theme: themeName } = usePageModeContext();

  const { planName, paymentCycle, planEndDate, pricePerMonth } =
    appContext.currentPlanDetails!;
  const currentPlanPrice = currencyToString(pricePerMonth);
  const modalHeaderProps: ModalHeaderProps = {
    planName,
    currentPlanPrice,
    paymentCycle,
    planEndDate,
  };

  return (
    <Modal
      isOpen={isOpen}
      dataHook='view-current-plan-modal'
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
    >
      <CustomModalLayout
        width='600px'
        title={t('Advanced.Plans_change.plan_modal.view_current_plan_title')}
        subtitle={<ModalHeader {...modalHeaderProps} />}
        primaryButtonText={t('change_plan.current_plan_modal.close')}
        primaryButtonOnClick={closeModal}
        onCloseButtonClick={closeModal}
      >
        <div className={classNames(s.lineSeparator, themeName)} />
        <CurrentPlanFeatures />
        {shouldShowPlanRemoved && (
          <PlanRemovedSectionHelper planName={planName} />
        )}
      </CustomModalLayout>
    </Modal>
  );
};

export const ViewCurrentPlanModal = withInjectedRootStore(
  ViewCurrentPlanModalComp,
);
